module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": 220
          }
        }, [_c('v-card-title', {
          staticClass: "headline pb-1"
        }, [_vm._v(_vm._s(_vm.summary.title))]), _vm._v(" "), _c('v-divider', {
          staticClass: "ma-0 pa-0"
        }), _vm._v(" "), _c('v-card-subtitle', [_c('div', {
          staticClass: "pa-0 ma-0 body-1 white--text"
        }, [_c('div', {
          staticClass: "d-flex flex-row justify-space-between"
        }, [_c('div', [_vm._v("Projected :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.summary.projected))])])]), _vm._v(" "), _c('div', {
          staticClass: "pa-0 ma-0 body-1 white--text"
        }, [_c('div', {
          staticClass: "d-flex flex-row justify-space-between"
        }, [_c('div', [_vm._v("Actual :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.summary.actual))])])]), _vm._v(" "), _c('div', {
          staticClass: "pl-1"
        }, _vm._l((_vm.summary.actualTasks), function(task, index) {
          return _c('div', {
            key: index,
            staticClass: "pa-0 ma-0"
          }, [_c('div', {
            staticClass: "d-flex flex-row justify-space-between"
          }, [_c('div', [_vm._v(_vm._s(task.title) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(task.value))])])])
        }), 0)])], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e37b5d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/Timeline/CardSummary.vue
// module id = 2060
// module chunks = 0